export default __webpack_public_path__ + "media/zurb/img/events/wired/sacred-heart/sacred-heart-thumb-f038fad4832fb8cb975845e58d1616e1.png";